import React from 'react';
import { Copy, Trash2, MoreVertical, Clock, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ManualEntryInlineActionsProps {
  onDuplicate?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
  /** When provided, a "Classify overtime" item is shown above the separator */
  onClassifyOvertime?: () => void;
}

export const ManualEntryInlineActions: React.FC<ManualEntryInlineActionsProps> = ({
  onDuplicate,
  onDelete,
  disabled = false,
  onClassifyOvertime,
}) => {
  const hasActions = !!(onClassifyOvertime || onDuplicate || onDelete);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 hover:bg-accent text-muted-foreground hover:text-foreground"
          data-tour="timesheet-row-actions"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {hasActions ? (
          <>
            {onClassifyOvertime && (
              <>
                <DropdownMenuItem onClick={onClassifyOvertime}>
                  <Clock className="h-4 w-4 mr-2" />
                  Classify overtime
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}
            {onDuplicate && (
              <DropdownMenuItem onClick={onDuplicate}>
                <Copy className="h-4 w-4 mr-2" />
                Duplicate
              </DropdownMenuItem>
            )}
            {onDelete && (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={onDelete}
                  className="text-destructive focus:text-destructive"
                >
                  <Trash2 className="h-4 w-4 mr-2" />
                  Delete
                </DropdownMenuItem>
              </>
            )}
          </>
        ) : (
          <DropdownMenuItem disabled className="text-muted-foreground">
            <Lock className="h-4 w-4 mr-2" />
            Read-only
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
